import { SET_LOGOUT, CLEAR_ALL } from '../../../store/Types';

export const GETALL_RESERVACIONES_CLASES = 'GETALL_RESERVACIONES_CLASES';
export const ACTIVO_RESERVACIONES_CLASES = 'ACTIVO_RESERVACIONES_CLASES';
export const LOADING_GETALL_RESERVACIONES_CLASES =
  'LOADING_GETALL_RESERVACIONES_CLASES';
export const PARAMS_RESERVACIONES_CLASES = 'PARAMS_RESERVACIONES_CLASES';

const initialState = {
  all: [],
  activo: null,
  loadingGetAll: false,
  params: {},
};

export const reservacionesClasesReducer = (state = initialState, action) => {
  switch (action.type) {
    case GETALL_RESERVACIONES_CLASES:
      return {
        ...state,
        all: action.payload.data,
        links: action.payload.links,
        meta: action.payload.meta,
      };
    case CLEAR_ALL:
      return {
        ...state,
        ...initialState,
      };
    case ACTIVO_RESERVACIONES_CLASES:
      return {
        ...state,
        activo: action.payload,
      };
    case LOADING_GETALL_RESERVACIONES_CLASES:
      return {
        ...state,
        loadingGetAll: action.payload,
      };
    case PARAMS_RESERVACIONES_CLASES:
      return {
        ...state,
        params: action.payload,
      };
    case SET_LOGOUT:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};
